module.exports = __webpack_public_path__ + "img/white-gray-transition-clean.41d924bf.png";